import service from '@/store/services/fms/driver_additional_fee-service';

const state = {
  list: {},
  driver_additional_fee: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, driver_additional_fee) => {
    state.driver_additional_fee = driver_additional_fee;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },


  get({commit, dispatch}, params) {
    return service.get(params)
      .then((driver_additional_fee) => { commit('SET_RESOURCE', driver_additional_fee); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((driver_additional_fee) => { commit('SET_RESOURCE', driver_additional_fee); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((driver_additional_fee) => { commit('SET_RESOURCE', driver_additional_fee); });
  },

  update_status({commit, dispatch}, params) {
    return service.update_status(params)
      .then((driver_additional_fee) => { commit('SET_RESOURCE', driver_additional_fee); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((driver_additional_fee) => { commit('SET_RESOURCE', driver_additional_fee); });
  },

  bill_payment({commit, dispatch}, params) {
    return service.bill_payment(params)
      .then((driver_additional_fee) => { commit('SET_RESOURCE', driver_additional_fee); });
  },

  LisOutstanding({commit, dispatch}, params) {
    return service.LisOutstanding(params)
      .then((driver_additional_fee) => { commit('SET_RESOURCE', driver_additional_fee); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  driver_additional_fee: state => state.driver_additional_fee,
  page: state => state.meta.page,
};
 
const driver_additional_fee = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default driver_additional_fee;
